module.exports = __webpack_public_path__ + "img/07-01_Achieving Goals.1639b061.svg";